/**
 * this object contains colors that should only be used inside the ui-kit, it is not exported in the build package.
 * Examples of color saved here are things like button background color for pressed/hover/focus states. These are reused
 * between the mobile and web versions, but should not be accessible to be used in the clients.
 */
export const privatePalette = {
  buttonBg: {
    hover: {
      containedPrimary: '#003947',
      containedSecondary: '#C3EFED',
      containedDesctructive: '#6A1E16',
    },
    pressed: {
      containedPrimary: '#002933',
      containedSecondary: '#AFE9E7',
    },
  },
};
